import { usePersistStore } from '@/shared/lib/store';
import { ToolTip } from '@/shared/ui';
import newImg from '@/shared/publish/ui/assets/images/ttukttak/common/icon/new.svg';

export const PublishOptionStep1 = ({
    checkNameList,
    onClear,
    purpose,
    setPurpose,
}: {
    checkNameList: string[];
    onClear: (type?: 'clear' | 'tab') => void;
    purpose?: DATA.PurposeType;
    setPurpose: (val: DATA.PurposeType) => void;
}) => {
    const { classMemberListRefreshTrigger, setClassMemberListRefreshTrigger } = usePersistStore();
    const step1Arr = [
        {
            type: 'online',
            data: [
                {
                    value: 'class',
                    label: '비바클래스 발행',
                    element: (
                        <>
                            <span className="new">
                                <img src={newImg} alt="new" />
                            </span>
                            <p className="info_title">비바클래스 발행</p>
                            <p className="info2">
                                비바클래스 학생들에게 평가를
                                <br />
                                발행할 수 있어요.
                            </p>
                        </>
                    ),
                },
                {
                    value: 'URL',
                    label: 'URL 응시 발행',
                    element: (
                        <>
                            <p className="info_title">URL 응시 발행</p>
                            <p className="info2">
                                누구나 응시 URL에 접속하여
                                <br />
                                닉네임을 입력하고 응시할 수 있어요.
                            </p>
                        </>
                    ),
                },
            ],
        },
        {
            type: 'offline',
            data: [
                {
                    value: 'output',
                    label: '시험지 출력',
                    element: (
                        <>
                            <p className="info_title">시험지 출력</p>
                            <p className="info2">
                                현재 베타 서비스 중이므로
                                <br />
                                출력 변환이 불안정할 수 있습니다.
                            </p>
                        </>
                    ),
                },
            ],
        },
    ];

    const checkDisableMenu = () => false;

    return (
        <div className="set-file-box cont-mt step1">
            <div className="set-file-header">
                <div className="set-file-title">
                    <h3 className="title step_tab_title">STEP 1</h3>
                </div>
            </div>
            <div className="set-file-content content-type1">
                <div className="form-row">
                    <div className="form-label size-type1 title_wrap">
                        <div className="option_title">제목</div>
                    </div>
                    <div className="form-td">
                        <div className="cont_wrap">
                            <div className="cont_wrap_inner">
                                <div className="text-box borderBox title-box">
                                    <ul className="scroll-box">
                                        {checkNameList &&
                                            checkNameList.map((e, i) => (
                                                <li key={`check-name-${i}`}>{e ?? '-'}</li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 용도 */}
                <div className="form-row baseline">
                    <div className="form-label size-type1 title_wrap baseline">
                        <div className="option_title">용도</div>
                    </div>
                    <div className="form-td">
                        <div className="cont_wrap">
                            <div className="flex_b radiobtn_wrap">
                                {step1Arr.map((e) => (
                                    <div
                                        key={`${e.type}-purpose-wrap`}
                                        className={`${e.type}_wrap`}
                                    >
                                        <p className="type_title">
                                            {e.type === 'online' ? '온라인' : '오프라인'} 평가
                                        </p>
                                        <div className="flex_s">
                                            {e.data.map((el, il) => (
                                                <div
                                                    className={`chk-group chk-radioBtn ${e.type === 'online' && 'type2'} `}
                                                    key={`${e.type}-${el.value}`}
                                                >
                                                    <input
                                                        disabled={checkDisableMenu()}
                                                        type="radio"
                                                        id={`rdo${e.type === 'online' ? il + 1 : il + 3}`}
                                                        name="rdo"
                                                        value={el.value}
                                                        checked={purpose === el.value}
                                                        onChange={(e) => {
                                                            if (el.value === 'class') {
                                                                setClassMemberListRefreshTrigger(
                                                                    classMemberListRefreshTrigger +
                                                                        1
                                                                );
                                                            }
                                                            onClear('tab');
                                                            setPurpose(
                                                                e.target.value as DATA.PurposeType
                                                            );
                                                        }}
                                                    />
                                                    {checkDisableMenu() ? (
                                                        <ToolTip
                                                            msg={
                                                                <p className="tip-txt">
                                                                    Coming Soon
                                                                </p>
                                                            }
                                                            pos="top"
                                                        >
                                                            <label
                                                                className="input-chk"
                                                                htmlFor={`rdo${e.type === 'online' ? il + 1 : il + 3}`}
                                                            >
                                                                <div className="info_wrap">
                                                                    {el.element}
                                                                </div>
                                                            </label>
                                                        </ToolTip>
                                                    ) : (
                                                        <label
                                                            className="input-chk"
                                                            htmlFor={`rdo${e.type === 'online' ? il + 1 : il + 3}`}
                                                        >
                                                            <div className="info_wrap">
                                                                {el.element}
                                                            </div>
                                                        </label>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
